import { gql } from "@apollo/client";

const USER_FIELDS = gql`
  fragment UserSuggestionsForSearchFields on User {
    _id
    avatar
    username
    steam {
      steamid
      personaname
    }
  }
`;

const USER_SUGGESTIONS_FOR_SEARCH = (useGraphQuery: boolean) => gql`
  ${USER_FIELDS}

  ${useGraphQuery
    ? `
    query getMeUserSuggestionsForSearch($count: Int, $removeFollows: Boolean) {
      me {
        suggestions(limit: $count, removeFollows: $removeFollows) {
          user { 
            ...UserSuggestionsForSearchFields 
          }
          reason
          score
        }
      }
    }
  `
    : `
    query userSuggestionsForSearchControl($count: Int) {
      me {
        suggestions(limit: $count) {
          user {
            ...UserSuggestionsForSearchFields
          }
          reason
          score
        }
      }
    }
  `}
`;

export { USER_SUGGESTIONS_FOR_SEARCH };
